import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExitInterviewDTO  {
    _originalTypeClassName = "zERP.BO.ExitInterviewDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExitInterviewDTO.translate = translateService;
}
this.InterviewId = null;
this.InterviewDate = null;
this.Fullname = null;
this.Interview = null;
this.FilePath = null;
this.ExitInterviewDTOKey = null;
this._key = this.ExitInterviewDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
InterviewId:any;
InterviewDate:any;
Fullname:any;
Interview:any;
FilePath:any;
private _ExitInterviewDTOKey:any;
get ExitInterviewDTOKey(): any {
    return this._ExitInterviewDTOKey;
  }
set ExitInterviewDTOKey(value: any) {
    this._ExitInterviewDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ExitInterviewDTOKey == null || $this.ExitInterviewDTOKey == 0;
            }


}